export default {
  mounted() {
    this.slideMs = 4600
    this.index = 0
    this.timers = []
    this.slides = Array.from(this.el.querySelectorAll("[data-login-slide]"))

    const video = this.el.querySelector("[data-login-video]")
    if (video) {
      video.muted = true
      video.loop = true
      video.playsInline = true

      const tryPlay = () => video.play().catch(() => {})
      tryPlay()
      video.addEventListener("canplay", tryPlay, { once: true })
    }

    this.timers.push(setTimeout(() => this.scheduleNext(), 280))
  },

  destroyed() {
    this.clearTimers()
  },

  scheduleNext() {
    this.timers.push(setTimeout(() => this.advance(), this.slideMs))
  },

  advance() {
    if (this.slides.length <= 1) return

    this.slides[this.index].classList.remove("is-active")
    this.index = (this.index + 1) % this.slides.length

    this.timers.push(setTimeout(() => {
      this.slides[this.index].classList.add("is-active")
      this.scheduleNext()
    }, 480))
  },

  clearTimers() {
    this.timers.forEach((timer) => clearTimeout(timer))
    this.timers = []
  }
}
